import * as React from "react";
import { forwardRef } from "react";
const SvgUnlockOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	strokeWidth: 1.2,
	viewBox: "0 0 14 18",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M3.857 8.607V4.68a3.143 3.143 0 0 1 6.286 0m-8.643 5.5a1.57 1.57 0 0 1 1.571-1.572h7.858A1.57 1.57 0 0 1 12.5 10.18v4.714a1.57 1.57 0 0 1-1.571 1.571H3.07A1.57 1.57 0 0 1 1.5 14.893zm4.714 2.357a.786.786 0 1 0 1.572 0 .786.786 0 0 0-1.572 0",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgUnlockOutlined);
export default ForwardRef;
